export const NS_CODE_DISPLAY_COMPONENTS = "code-display-components";

export enum K {
  COPY_TOOLTIP = "COPY_TOOLTIP",
  EXPORT_TOOLTIP = "EXPORT_TOOLTIP",
}

export type Locale = { [key in K]: string };
